import { FC } from 'react';
import { ImageUploadField } from '../ImageUploadField';

interface MediaSectionProps {
  logo: string;
  photo: string;
  background: string;
  image1: string;
  image2: string;
  speakerPhoto: string;
  onLogoChange: (value: string) => void;
  onPhotoChange: (value: string) => void;
  onBackgroundChange: (value: string) => void;
  onImage1Change: (value: string) => void;
  onImage2Change: (value: string) => void;
  onSpeakerPhotoChange: (value: string) => void;
  onLogoUpload: (file: File) => Promise<void>;
  onPhotoUpload: (file: File) => Promise<void>;
  onBackgroundUpload: (file: File) => Promise<void>;
  onImage1Upload: (file: File) => Promise<void>;
  onImage2Upload: (file: File) => Promise<void>;
  onSpeakerPhotoUpload: (file: File) => Promise<void>;
  uploadingLogo: boolean;
  uploadingPhoto: boolean;
  uploadingBackground: boolean;
  uploadingImage1: boolean;
  uploadingImage2: boolean;
  uploadingSpeakerPhoto: boolean;
  shouldShowLogo: boolean;
  shouldShowPhoto: boolean;
  shouldShowBackground: boolean;
  shouldShowImage1: boolean;
  shouldShowImage2: boolean;
  shouldShowSpeakerPhoto: boolean;
  disabled?: boolean;
  getImageUrl?: (path: string) => string; // Optional helper to get display URL
}

export const MediaSection: FC<MediaSectionProps> = ({
  logo,
  photo,
  background,
  image1,
  image2,
  speakerPhoto,
  onLogoChange,
  onPhotoChange,
  onBackgroundChange,
  onImage1Change,
  onImage2Change,
  onSpeakerPhotoChange,
  onLogoUpload,
  onPhotoUpload,
  onBackgroundUpload,
  onImage1Upload,
  onImage2Upload,
  onSpeakerPhotoUpload,
  uploadingLogo,
  uploadingPhoto,
  uploadingBackground,
  uploadingImage1,
  uploadingImage2,
  uploadingSpeakerPhoto,
  shouldShowLogo,
  shouldShowPhoto,
  shouldShowBackground,
  shouldShowImage1,
  shouldShowImage2,
  shouldShowSpeakerPhoto,
  disabled = false,
  getImageUrl,
}) => {
  return (
    <>
      {shouldShowLogo && (
        <ImageUploadField
          label="Logo"
          value={logo}
          onChange={onLogoChange}
          onUpload={onLogoUpload}
          uploading={uploadingLogo}
          disabled={disabled}
          required
          getImageUrl={getImageUrl}
        />
      )}

      {shouldShowPhoto && (
        <ImageUploadField
          label="Photo"
          value={photo}
          onChange={onPhotoChange}
          onUpload={onPhotoUpload}
          uploading={uploadingPhoto}
          disabled={disabled}
          getImageUrl={getImageUrl}
        />
      )}

      {shouldShowBackground && (
        <ImageUploadField
          label="Background Image"
          value={background}
          onChange={onBackgroundChange}
          onUpload={onBackgroundUpload}
          uploading={uploadingBackground}
          disabled={disabled}
          getImageUrl={getImageUrl}
        />
      )}

      {shouldShowImage1 && (
        <ImageUploadField
          label="Image 1"
          value={image1}
          onChange={onImage1Change}
          onUpload={onImage1Upload}
          uploading={uploadingImage1}
          disabled={disabled}
          getImageUrl={getImageUrl}
        />
      )}

      {shouldShowImage2 && (
        <ImageUploadField
          label="Image 2"
          value={image2}
          onChange={onImage2Change}
          onUpload={onImage2Upload}
          uploading={uploadingImage2}
          disabled={disabled}
          getImageUrl={getImageUrl}
        />
      )}

      {shouldShowSpeakerPhoto && (
        <ImageUploadField
          label="Speaker Photo"
          value={speakerPhoto}
          onChange={onSpeakerPhotoChange}
          onUpload={onSpeakerPhotoUpload}
          uploading={uploadingSpeakerPhoto}
          disabled={disabled}
          getImageUrl={getImageUrl}
        />
      )}
    </>
  );
};

